export const routesGunlukIsler = [
  {
    path: "/gunlukisler",
    name: "gunlukisler",
    component: () => import("@/views/gunlukisler/index.vue"),
    meta: {
      public: false,
      title: "gunlukisler.Baslik",
      yetki: { k: [2003002] },
    },
  },
]
